
export default function () {

  return {
    // item: null,
    // tempItem: null,
    // items: [],
    // skip: 0,
    // limit: 12,
    // total: 0,
    // orderBy: '',
    // orderDesc: false,
    // searchBy: [],
    // searchQuery: '',
    // where: {},
    // loading: false,
    // include: [],
    // fields: [],
  };
}
